/**
 * @generated SignedSource<<e27a297fcb9a8f467949de9681cd130f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpEstimateSimilarSold_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowPricingGuidance_item">;
  readonly " $fragmentType": "usePdpEstimateSimilarSold_item";
};
export type usePdpEstimateSimilarSold_item$key = {
  readonly " $data"?: usePdpEstimateSimilarSold_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpEstimateSimilarSold_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpEstimateSimilarSold_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "76bd5bd6e91fe640a21acf01ec820e97";

export default node;
